<template>            
    <img v-if="status == 'progress'" src="./icon/progress.svg">
    <img v-if="status == 'done'" src="./icon/done.svg">
    <img v-if="status == 'fail'" src="./icon/fail.svg">    
</template>
<script>

/*  
    <CheckIcon status="done"/>
    <CheckIcon status="fail"/>
    <CheckIcon/>
*/

export default {
    data: function () {return {}},
    props:{
        status: {type: String, default:'progress'},        
    },    
}
</script>
